import commonEnHK from './common_en-HK'

const fnbEnHK = {
  fnb: {
    ...commonEnHK,
  }
}

export default fnbEnHK